(function() {
  'use strict';

  angular
    .module('quizSite', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'angularytics', '720kb.socialshare']);

})();

(function() {
  'use strict';

  angular
  .module('quizSite')
  .directive('rangeSlider', rangeSlider);

  /** @ngInject */
  function rangeSlider($log) {
    var directive = {
      restrict: 'E',
      template: '<div id="input-wrapper">'+
      '<input class="scrollable" id="rangeslider" ng-model="questions.question.score" type="range" min="0" max="10" value="5" step="0.05">'+
      '<div id="reel"><div id="rn"></div></div>'+
      '<div id="static-output"></div>'+
      '</div>',
      link: function(scope, element, attrs) {

        var input = element.find('input[type=range]'),
        min = input.attr('min'),
        max = input.attr('max');

        var rn = "";
        for(var i = min; i <= max; i++)
        rn += "<span>"+i+"</span>";
        element.find('#rn').html(rn);

        updateOutput(scope.questions.question.score)

        function updateOutput(figure, activate) {

          var inputWrapper = element.find('#input-wrapper'),
              staticOutput = element.find('#static-output'),
              reel = element.find('#reel'),
              rn = element.find('#rn');
          //if activate then add .active to #input-wrapper to help animate the #reel
          // if(activate)
          //   inputWrapper.addClass("active");

          //because of the step param the slider will return values in multiple of 0.05 so we have to round it up
          var rfigure = Math.round(figure);
          //displaying the static output
          staticOutput.html(rfigure);

          //positioning #static-output and #reel
          //horizontal positioning first
          var h = (figure/max*(inputWrapper.width()-reel.width()))+2 + 'px';
          //vertical positioning of #rn
          var v = rfigure*reel.height()*-1 + 'px';

          //applying the positions
          element.find("#static-output, #reel").css({left: h});
          //#rn will be moved using transform+transitions for better animation performance. The false translateZ triggers GPU acceleration for better performance.
          rn.css({transform: 'translateY('+v+') translateZ(0)'});
        }

        scope.$watch('questions.question.score', function(){
          updateOutput(scope.questions.question.score);
        });


        element.bind('mousedown touchstart',function(e){
          element.find('#input-wrapper').addClass('active');
        });
        element.bind('mouseup touchend',function(){
          element.find('#input-wrapper').removeClass('active');
        });
      }
    }

      return directive;
    }

  })();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .directive('mobile', mobile);

  /** @ngInject */
  function mobile($window) {
    var directive = {
      restrict: 'A',
      link: function(scope, element) {

        var w = angular.element($window);
        var onresize = function(){
          if ( w.width() - w.height() < -50)
            element.addClass('mobile');
          else
            element.removeClass('mobile');
        }

        onresize();

        w.bind('resize', onresize);
      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .directive('result', results);

  /** @ngInject */
  function results($window) {
    var directive = {
      restrict: 'C',
      link: function(scope, element) {

        angular.element(document).find('footer.main').hide();

      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .directive('hero', hero);

  /** @ngInject */
  function hero($window) {
    var directive = {
      restrict: 'C',
      link: function(scope, element) {

        var w = angular.element($window),
            onresize = function(){
              var wh = w.height(),
                   h = element.height(),
                   m = (wh-h)/2; // screen center

                   // Offset for positioning
                  //  m += 10;

                  if (m < 0)
                    m = 0;
                  //  m = Math.abs(m);
              element.css('marginTop', m);
            }

          onresize();

          w.bind('resize', onresize);
      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .factory('quiz', quiz);

  /** @ngInject */
  function quiz($http, $location) {

    var questions = [
      { trait: "Motivated", score: 5 },
      { trait: "Self-confident", score: 5 },
      { trait: "Healthy", score: 5 },
      { trait: "Successful", score: 5 },
      { trait: "Optimistic", score: 5 },
      { trait: "Fulfilled", score: 5 },
      { trait: "Self-worth", score: 5 },
      { trait: "Happy", score: 5 },
      { trait: "Energized", score: 5 },
      { trait: "Productive", score: 5 }
    ];

    var getTotalScore = function(){
      var totalScore = 0;

      questions.forEach(function(el){
        totalScore += Math.round(el.score);
      });

      return totalScore;
    }

    var getAverageScore = function(){
      var totalScore = getTotalScore();

      return Math.round(totalScore / questions.length);
    }

    var trackActivity = function(type, name, score){
      $http({
        method: 'POST',
        url: '/track-quiz',
        data: {
          url: $location.path(),
          type: type,
          name: name,
          score: score || 0
        }
      });
    }

    var init = false;
    var popup = false;

    var service = {
      questions: questions,
      getTotalScore: getTotalScore,
      getAverageScore: getAverageScore,
      trackActivity: trackActivity,
      init: init,
      popup: popup
    };

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .controller('ResultsController', ResultsController);

  /** @ngInject */
  function ResultsController($scope, $stateParams, quiz, $state, $log, $location) {
    var vm = this;

    vm.siteUrl = $location.host();
    vm.fbAppId = '190400524650423';

    if (vm.siteUrl == 'localhost' || vm.siteUrl == 'staging.instinctivedrives.com'){
      vm.siteUrl = 'staging.instinctivedrives.com';
      vm.fbAppId = '1516136835355454'
    }

    vm.siteUrl = 'http://'+vm.siteUrl;

    quiz.trackActivity('result', $state.current.name, quiz.getAverageScore());
  }
})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $log, $location, $state, quiz) {
    var vm = this;
    vm.creationDate = 1452696538818;

    vm.startQuiz = function() {
      $log.log('yo');
      quiz.init = true;
      $location.path('/question/1');
    }

    angular.element(document).find('footer.main').show();
    quiz.trackActivity('homepage', $state.current.name);


    // Social follow popup
    setTimeout(function(){
      angular.element(document).find('#modal-social .close').click(function(){
        angular.element(document).find('#modal-social').fadeOut();
      });

      angular.element(document).mouseleave(function(){
        if (!quiz.popup) {
          quiz.popup = true;
          angular.element(document).find('#modal-social').fadeIn();
        }
      });
    }, 10000);

  }
})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .controller('QuestionsController', QuestionsController);

  /** @ngInject */
  function QuestionsController($scope, $stateParams, quiz, $log, $location, $state) {
    var vm = this;
    var questionId = $stateParams.id - 1,
        nextId = $stateParams.id+1;

    if (!quiz.init)
      $location.path('/');

    vm.list = quiz.questions;
    vm.question = quiz.questions[questionId];

    vm.buttonLabel = (quiz.questions.length < nextId) ? 'Finish' : 'Next';

    vm.next = function() {

      $log.log(quiz.getTotalScore());

      if (quiz.questions.length < nextId) {
        var averageScore = quiz.getAverageScore();
        $log.log(averageScore);
        if (averageScore <= 4) {
          $state.go('diving');
        } else if (averageScore <= 7) {
          $state.go('surviving');
        } else if (averageScore >= 8) {
          $state.go('thriving');
        }
      } else {
        quiz.trackActivity('question', vm.question.trait, Math.round(vm.question.score));
        $location.path('/question/'+nextId);
      }
    }

    angular.element(document).find('footer.main').show();
  }
})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, Angularytics, $rootScope, $window) {

    var userAgent = $window.navigator.userAgent;

    if (userAgent.indexOf("SM-G800Y")!=-1)
      $rootScope.pageTransition = 'crossFade';

    $log.debug('runBlock end');
    Angularytics.init();

    // Uses document because document will be topmost level in bubbling
    angular.element(document).on('touchmove',function(e){
      e.preventDefault();
    });

    var scrolling = false;

    // Uses body because jquery on events are called off of the element they are
    // added to, so bubbling would not work if we used document instead.
    angular.element('body').on('touchstart','.scrollable',function(e) {

        // Only execute the below code once at a time
        if (!scrolling) {
            scrolling = true;
            if (e.currentTarget.scrollTop === 0) {
              e.currentTarget.scrollTop = 1;
            } else if (e.currentTarget.scrollHeight === e.currentTarget.scrollTop + e.currentTarget.offsetHeight) {
              e.currentTarget.scrollTop -= 1;
            }
            scrolling = false;
        }
    });

    // Prevents preventDefault from being called on document if it sees a scrollable div
    angular.element('body').on('touchmove','.scrollable',function(e) {
      e.stopPropagation();
    });

  }

})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('quiz',{
        url: '/question/{id:int}',
        templateUrl: 'app/questions/questions.html',
        controller: 'QuestionsController',
        controllerAs: 'questions'
      })
      .state('result', {
        url: "/result",
        templateUrl: "app/results/results.html",
        controller: 'ResultsController',
        controllerAs: 'results'
      })
      .state('thriving', {
        url: "/result/thriving",
        templateUrl: "app/results/thriving.html",
        controller: 'ResultsController',
        controllerAs: 'results'
      })
      .state('surviving', {
        url: "/result/surviving",
        templateUrl: "app/results/surviving.html",
        controller: 'ResultsController',
        controllerAs: 'results'
      })
      .state('diving', {
        url: "/result/diving",
        templateUrl: "app/results/diving.html",
        controller: 'ResultsController',
        controllerAs: 'results'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('quizSite');
    // .constant('malarkey', malarkey)
    // .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('quizSite')
    .config(config);

  /** @ngInject */
  function config($logProvider, AngularyticsProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    AngularyticsProvider.setEventHandlers(['Console', 'GoogleUniversal']);

  }

})();

angular.module("quizSite").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"title\"><div class=\"container\"><div class=\"hero\" centered=\"\"><h1>Are you <strong>thriving</strong><br>or just surviving?</h1><a ng-click=\"main.startQuiz()\" class=\"btn big\">Take our quick quiz</a></div></div></div>");
$templateCache.put("app/questions/questions.html","<div class=\"question {{ questions.question.trait | lowercase }}\"><div class=\"container hero\"><p class=\"ifeel\">I feel...</p><h1>{{ questions.question.trait }}</h1><div class=\"input-container\" mobile=\"\"><p class=\"left\">Never</p><p class=\"mobile top\">Always</p><range-slider></range-slider><p class=\"right\">Always</p><p class=\"mobile bottom\">Never</p></div><a mobile=\"\" class=\"btn white\" ng-click=\"questions.next()\">{{ questions.buttonLabel }}</a></div></div>");
$templateCache.put("app/results/diving.html","<div class=\"diving result scrollable\"><div class=\"container hero\"><p class=\"sub\">Uh-oh!</p><h1>You are diving not thriving</h1><p>You’re likely experiencing stress and frustration and possibly significant physical or emotional symptoms. Your situation is not sustainable! You need to take action NOW to avoid more serious stress and health issues.</p><div class=\"info\"><h2>What can you do?</h2><ol><li><p>What is causing you the greatest stress or frustration? Identify the first step you can take to get things moving in the right direction.</p></li><li><p>Think of a time when you felt successful and fulfilled. List the things you had then and don’t have now. How can you get more of what you need?</p></li><li><p><strong>Discover your Instinctive Drives!</strong> Find your personal formula for success and fulfillment and identify what you need to reduce your stress and to thrive.</p></li></ol></div><ul class=\"social\"><li class=\"li\"><a socialshare=\"\" socialshare-provider=\"linkedin\" socialshare-text=\"I am Diving...\" socialshare-description=\"I just took the Instinctive Drives peak performance quiz and I’m Diving… Find out if you’re thriving, surviving or diving\" socialshare-tags=\"instinctivedrives\" socialshare-url=\"{{ results.siteUrl + \'/quiz\' }}\"><div><i class=\"fa fa-linkedin\"></i></div><span>Share on<br></span>LinkedIn</a></li><li class=\"fb\"><a socialshare=\"\" socialshare-provider=\"facebook\" socialshare-url=\"{{ results.siteUrl + \'/quiz\' }}\" socialshare-text=\"I am Diving...\" socialshare-description=\"I just took the Instinctive Drives peak performance quiz and I’m Diving… Find out if you’re thriving, surviving or diving\" socialshare-media=\"{{ results.siteUrl + \'/quiz/assets/images/fb-diving.jpg\' }}\" socialshare-type=\"feed\" socialshare-via=\"{{ results.fbAppId }}\" socialshare-ref=\"dive\" socialshare-tags=\"instinctivedrives\" socialshare-redirect-uri=\"{{ results.siteUrl }}\" socialshare-popup-width=\"600\"><div><i class=\"fa fa-facebook\"></i></div><span>Share on</span>Facebook</a></li><li class=\"tw\"><a socialshare=\"\" socialshare-provider=\"twitter\" socialshare-text=\"I just took the Instinctive Drives peak performance quiz and I’m Diving…\" socialshare-url=\"http://bit.ly/249kKq7\" socialshare-via=\"Get_your_VACI\" socialshare-hashtags=\"instinctivedrives\"><div><i class=\"fa fa-twitter\"></i></div><span>Tweet on</span>Twitter</a></li></ul><div class=\"center\"><a class=\"btn\" href=\"/\">Get your I.D.</a></div></div></div>");
$templateCache.put("app/results/results.html","");
$templateCache.put("app/results/surviving.html","<div class=\"surviving result scrollable\"><div class=\"container hero\"><p class=\"sub\">Caution!</p><h1>You are surviving but not thriving</h1><p>You’re generally ok – you may feel great about some areas of your life but not others. Things don’t seem terrible, but you know that you could be happier, healthier and more successful.</p><div class=\"info\"><h2>What can you do?</h2><ol><li><p>Identify one thing you can do right now to change your situation or feel better – write it down – now go do it!</p></li><li><p>Think about times in your life when you felt at the top of your game. How can you get more of what you need to get that feeling back?</p></li><li><p><strong>Discover your Instinctive Drives!</strong> You’ll find out exactly what you need to find greater and more consistent levels of success and fulfillment.</p></li></ol></div><ul class=\"social\"><li class=\"li\"><a socialshare=\"\" socialshare-provider=\"linkedin\" socialshare-text=\"I am Surviving...\" socialshare-description=\"I just took the Instinctive Drives peak performance quiz and I’m Surviving… Find out if you’re thriving or just surviving\" socialshare-tags=\"instinctivedrives\" socialshare-url=\"{{ results.siteUrl + \'/quiz\' }}\"><div><i class=\"fa fa-linkedin\"></i></div><span>Share on<br></span>LinkedIn</a></li><li class=\"fb\"><a socialshare=\"\" socialshare-provider=\"facebook\" socialshare-url=\"{{ results.siteUrl + \'/quiz\' }}\" socialshare-text=\"I am Surviving...\" socialshare-description=\"I just took the Instinctive Drives peak performance quiz and I’m Surviving… Find out if you’re thriving or just surviving\" socialshare-media=\"{{ results.siteUrl + \'/quiz/assets/images/fb-surviving.jpg\' }}\" socialshare-type=\"feed\" socialshare-via=\"{{ results.fbAppId }}\" socialshare-ref=\"survi\" socialshare-tags=\"instinctivedrives\" socialshare-redirect-uri=\"{{ results.siteUrl }}\" socialshare-popup-width=\"600\"><div><i class=\"fa fa-facebook\"></i></div><span>Share on</span>Facebook</a></li><li class=\"tw\"><a socialshare=\"\" socialshare-provider=\"twitter\" socialshare-text=\"I just took the Instinctive Drives peak performance quiz and I’m Surviving…\" socialshare-url=\"http://bit.ly/249kKq7\" socialshare-via=\"Get_your_VACI\" socialshare-hashtags=\"instinctivedrives\"><div><i class=\"fa fa-twitter\"></i></div><span>Tweet on</span>Twitter</a></li></ul><div class=\"center\"><a class=\"btn\" href=\"/\">Get your I.D.</a></div></div></div>");
$templateCache.put("app/results/thriving.html","<div class=\"thriving result scrollable\"><div class=\"container hero\"><p class=\"sub\">Congratulations!</p><h1>You are THRIVING</h1><p>You’re operating at peak performance and meeting life’s challenges head on. Now, it’s about sustaining your high levels of success and fulfillment and discovering what comes next!</p><div class=\"info\"><h2>What can you do?</h2><ol><li><p>Reflect on what’s making life so great for you right now. If stress or frustration do kick in at any time you’ll know what you need to get back on top.</p></li><li><p>You’re on a roll! What big goal or a dream is still out there for you? Now is the time! What step can you take today to get things moving.</p></li><li><p><strong>Discover your Instinctive Drives!</strong> You’ll find out exactly what you need to ensure that you’re reaching your fullest potential.</p></li></ol></div><ul class=\"social\"><li class=\"li\"><a socialshare=\"\" socialshare-provider=\"linkedin\" socialshare-text=\"I am THRIVING!\" socialshare-description=\"I just took the Instinctive Drives peak performance quiz and I’m Thriving! Find out if you’re thriving or just surviving\" socialshare-tags=\"instinctivedrives\" socialshare-url=\"{{ results.siteUrl + \'/quiz\' }}\"><div><i class=\"fa fa-linkedin\"></i></div><span>Share on<br></span>LinkedIn</a></li><li class=\"fb\"><a socialshare=\"\" socialshare-provider=\"facebook\" socialshare-url=\"{{ results.siteUrl + \'/quiz\' }}\" socialshare-text=\"I am THRIVING!\" socialshare-description=\"I just took the Instinctive Drives peak performance quiz and I’m Thriving! Find out if you’re thriving or just surviving\" socialshare-media=\"{{ results.siteUrl + \'/quiz/assets/images/fb-thriving.jpg\' }}\" socialshare-type=\"feed\" socialshare-via=\"{{ results.fbAppId }}\" socialshare-ref=\"thrive\" socialshare-tags=\"instinctivedrives\" socialshare-redirect-uri=\"{{ results.siteUrl }}\" socialshare-popup-width=\"600\"><div><i class=\"fa fa-facebook\"></i></div><span>Share on</span>Facebook</a></li><li class=\"tw\"><a socialshare=\"\" socialshare-provider=\"twitter\" socialshare-text=\"I just took the Instinctive Drives peak performance quiz and I’m Thriving!\" socialshare-url=\"http://bit.ly/249kKq7\" socialshare-via=\"Get_your_VACI\" socialshare-hashtags=\"instinctivedrives\"><div><i class=\"fa fa-twitter\"></i></div><span>Tweet on</span>Twitter</a></li></ul><div class=\"center\"><a class=\"btn\" href=\"/\">Get your I.D.</a></div></div></div>");
$templateCache.put("app/components/social/social-follow.html","<section class=\"modal-show\" id=\"modal-social\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"modal-label\" aria-hidden=\"true\"><div class=\"close bg\"></div><div class=\"modal-inner\"><div class=\"close btn-close\">x</div><header id=\"modal-label\">Follow us!</header><div class=\"modal-content\"><ul class=\"social-follow\"><li><div class=\"fb-like\" data-href=\"https://www.facebook.com/InstinctiveDrives/\" data-layout=\"button_count\" data-action=\"like\" data-show-faces=\"true\" data-share=\"true\"></div></li><li><script type=\"IN/FollowCompany\" data-id=\"3581886\" data-counter=\"right\"></script></li><li><a href=\"https://twitter.com/Get_your_VACI\" class=\"twitter-follow-button\" data-show-count=\"false\" data-size=\"large\">Follow @Get_your_VACI</a></li></ul></div></div></section><script>!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?\'http\':\'https\';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+\'://platform.twitter.com/widgets.js\';fjs.parentNode.insertBefore(js,fjs);}}(document, \'script\', \'twitter-wjs\');</script><div id=\"fb-root\"></div><script>(function(d, s, id) {\n  var js, fjs = d.getElementsByTagName(s)[0];\n  if (d.getElementById(id)) return;\n  js = d.createElement(s); js.id = id;\n  js.src = \"//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.5\";\n  fjs.parentNode.insertBefore(js, fjs);\n}(document, \'script\', \'facebook-jssdk\'));</script><script src=\"//platform.linkedin.com/in.js\" type=\"text/javascript\"> lang: en_US</script>");}]);